import * as React from 'react';

import TextComponent from './text';

import { TextType } from '../../models/strapi/split_column';

import * as styles from './text.module.scss';

interface Props {
    data: TextType;
}

const StrapiText = (props: Props) => {
    const { data } = props;
    if (!props.data) {
        return <React.Fragment></React.Fragment>;
    }

    return (
        <div className={styles.markdown}>
            <TextComponent
                data={{
                    align: data.textAlign,
                    color: data.fontColor,
                    content: data.value
                }}
            />
        </div>
    );
};

export default StrapiText;
